export const gdpr = {
  routes: [
    {
      path: "/process",
      component: () => import("../organization-process-view"),
    },
  ],
};

export const workspace = {
  routes: [
    {
      path: "/workspace/library/process",
      component: () => import("../workspace-library-process-view"),
    },
  ],
};

export const management = {
  routes: [
  ],
};
